// The dashboard greets by IST, not by the viewer's clock: this is an India-run
// HRMS, so "good morning" should mean morning in the office, whether the person
// is reading it from Pune or from a hotel in another timezone.

const IST_HOUR = new Intl.DateTimeFormat("en-GB", {
  timeZone: "Asia/Kolkata",
  hour: "2-digit",
  hourCycle: "h23",
});

/** The hour 0-23 in Asia/Kolkata, whatever the viewer's own timezone is. */
export function istHour(now: Date = new Date()): number {
  return Number(IST_HOUR.format(now));
}

export interface Greeting {
  text: string;
  emoji: string;
}

/**
 * Bands are chosen so the boundaries read naturally in an Indian working day:
 * morning starts at 5, afternoon at noon, evening at 5pm. From 7pm until 5am
 * the greeting is "Welcome back", shown with a moon.
 */
export function greetingFor(hour: number): Greeting {
  if (hour >= 5 && hour < 12)  return { text: "Good morning",   emoji: "🌅" };
  if (hour >= 12 && hour < 17) return { text: "Good afternoon", emoji: "☀️" };
  if (hour >= 17 && hour < 19) return { text: "Good evening",   emoji: "🌆" };
  return { text: "Welcome back", emoji: "🌙" };
}

/** The full line: "Good morning, Deleshwar 🌅" — or without the name if unknown. */
export function greetingLine(firstName: string | null | undefined, now: Date = new Date()): string {
  const { text, emoji } = greetingFor(istHour(now));
  const name = firstName?.trim();
  return name ? `${text}, ${name} ${emoji}` : `${text} ${emoji}`;
}
